/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_TransitionProspectStatusRequest = {
    /**
     * ArchivedReason is the free text, required only when the code is `other`.
     */
    archived_reason?: string;
    /**
     * ArchivedReasonCode is required whenever status is ARCHIVED, and ignored
     * otherwise: every non-archive transition clears all three archive fields.
     */
    archived_reason_code?: prospects_TransitionProspectStatusRequest.archived_reason_code;
    status: prospects_TransitionProspectStatusRequest.status;
    version: number;
};
export namespace prospects_TransitionProspectStatusRequest {
    /**
     * ArchivedReasonCode is required whenever status is ARCHIVED, and ignored
     * otherwise: every non-archive transition clears all three archive fields.
     */
    export enum archived_reason_code {
        NO_INTEREST = 'no_interest',
        NO_CAPACITY = 'no_capacity',
        PRICE = 'price',
        OTHER_SOLUTION = 'other_solution',
        NO_SHOW = 'no_show',
        OTHER = 'other',
    }
    export enum status {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        TOUR_SCHEDULED = 'TOUR_SCHEDULED',
        TOUR_COMPLETED = 'TOUR_COMPLETED',
        FOLLOW_UP_OPEN = 'FOLLOW_UP_OPEN',
        CONTRACT_SENT = 'CONTRACT_SENT',
        CONTRACT_SIGNED = 'CONTRACT_SIGNED',
        ACTIVE = 'ACTIVE',
        ARCHIVED = 'ARCHIVED',
    }
}

